"use strict";

exports.__esModule = true;
exports.DeviceStatusOverlay = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _VimanaIcon = require("../../VimanaIcon");
var _Theme = require("../../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var OverlayContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "DeviceStatusOverlay__OverlayContentWrapper",
  componentId: "sc-h1ghg6-0"
})(["position:absolute;top:0;z-index:1;display:flex;justify-content:center;align-items:center;height:100%;width:100%;background:", ";"], (0, _Theme.val)("DeviceStatusOverlayBackground"));
var IconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "DeviceStatusOverlay__IconWrapper",
  componentId: "sc-h1ghg6-1"
})([""]);
var DeviceStatusOverlay = exports.DeviceStatusOverlay = function DeviceStatusOverlay(_ref) {
  var isDisconnected = _ref.isDisconnected,
    isLagging = _ref.isLagging,
    iconSize = _ref.iconSize;
  var renderOverlay = function renderOverlay() {
    var renderOverlayIcon = function renderOverlayIcon() {
      if (isDisconnected) {
        return /*#__PURE__*/_react["default"].createElement(IconWrapper, {
          "data-testid": "DeviceStatusOverlay.DisconnectionIcon"
        }, /*#__PURE__*/_react["default"].createElement(_VimanaIcon.VimanaIcon, {
          icon: "DisconnectionIcon",
          iconSize: iconSize,
          alt: "Disconnected"
        }));
      }
      if (isLagging) {
        return /*#__PURE__*/_react["default"].createElement(IconWrapper, {
          "data-testid": "DeviceStatusOverlay.LagIcon"
        }, /*#__PURE__*/_react["default"].createElement(_VimanaIcon.VimanaIcon, {
          icon: "LagIcon",
          iconSize: iconSize,
          alt: "Lagging"
        }));
      }
      return null;
    };
    var overlayToRender = renderOverlayIcon();
    if (overlayToRender) {
      return /*#__PURE__*/_react["default"].createElement(OverlayContentWrapper, {
        "data-testid": "DeviceStatusOverlay"
      }, overlayToRender);
    }
    return null;
  };
  return renderOverlay();
};